import { memo, useState } from 'react'
import { useTranslate } from '../../../hooks/language/use-translate'

export const RocketGameEarning = memo(() => {
  const searchParams = new URLSearchParams(window.location.search)
  const img = searchParams.get('img')
  const name = searchParams.get('name')
  const type = (searchParams.get('type') as 'gift' | 'item' | null) ?? 'gift'

  const { translate } = useTranslate()
  const [imgErrored, setImgErrored] = useState(false)

  function close() {
    if ('ReactNativeWebView' in window) {
      // @ts-ignore
      window.ReactNativeWebView.postMessage('close')
    }
  }

  return (
    <div
      className="relative flex h-screen w-screen items-center justify-center overflow-hidden"
      style={{
        background:
          'radial-gradient(120% 80% at 50% 0%, #4b1f8a 0%, #1d0e4a 55%, #0a0820 100%)',
      }}
    >
      {/* glow atrás do prêmio */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'radial-gradient(60% 50% at 50% 40%, rgba(255,200,80,0.35) 0%, rgba(255,200,80,0) 70%)',
        }}
      />

      {/* confetti / estrelinhas */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-50"
        style={{
          backgroundImage:
            'radial-gradient(circle at 15% 25%, #ffd166 1px, transparent 2px),' +
            'radial-gradient(circle at 80% 18%, #ef476f 1px, transparent 2px),' +
            'radial-gradient(circle at 30% 78%, #06d6a0 1px, transparent 2px),' +
            'radial-gradient(circle at 70% 70%, #118ab2 1px, transparent 2px),' +
            'radial-gradient(circle at 50% 12%, #fff 1px, transparent 2px)',
          backgroundSize:
            '180px 180px, 220px 220px, 150px 150px, 200px 200px, 250px 250px',
        }}
      />

      {/* Conteúdo sem card — direto sobre o gradiente */}
      <div
        className="relative z-10 flex flex-col items-center px-6"
        style={{ animation: 'pop-in 320ms cubic-bezier(.2,.9,.2,1.2) both' }}
      >
        {/* Chip de tipo */}
        <span
          className={`rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-white shadow ${
            type === 'item'
              ? 'bg-gradient-to-r from-sky-400 to-indigo-500'
              : 'bg-gradient-to-r from-amber-400 to-orange-500'
          }`}
        >
          {type === 'item' ? 'Item' : 'Presente'}
        </span>

        <span className="mt-2 text-center text-xl font-extrabold text-white drop-shadow">
          🎉 {translate('rocket-game-earning-you-won')} 🎉
        </span>

        {/* Prêmio: imagem direta com glow, sem moldura */}
        <div className="relative mt-3 flex h-32 w-32 items-center justify-center">
          <div
            aria-hidden
            className="absolute inset-0 rounded-full"
            style={{
              background:
                'radial-gradient(circle, rgba(255,210,120,0.55) 0%, rgba(255,210,120,0) 70%)',
            }}
          />
          {img && !imgErrored ? (
            <img
              src={img}
              alt={name ?? 'prize'}
              onError={() => setImgErrored(true)}
              className="relative max-h-full max-w-full object-contain drop-shadow-[0_6px_14px_rgba(0,0,0,0.45)]"
            />
          ) : (
            <span className="relative px-3 text-center text-sm font-bold text-white">
              {name ?? '?'}
            </span>
          )}
        </div>

        {name && (
          <span className="mt-2 max-w-full text-center text-base font-bold text-white drop-shadow">
            {name}
          </span>
        )}

        <button
          onClick={close}
          className="mt-4 rounded-full bg-white px-8 py-2 text-sm font-bold uppercase tracking-wider text-violet-700 shadow-lg transition active:scale-95"
        >
          {translate('rocket-game-earning-close')}
        </button>
      </div>

      <style>{`
        @keyframes pop-in {
          from { opacity: 0; transform: translateY(8px) scale(0.92); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>
  )
})

RocketGameEarning.displayName = 'RocketGameEarning'
